export default __webpack_public_path__ + "static/media/2419.9356b21a.png";